import { FunctionComponent } from "react";
import { cn } from "../../../utils/cn";

export interface SpinnerProps {
  className?: string;
  strokeClassName?: string;
  size?: string;
}

/**
 *
 */
export const Spinner: FunctionComponent<SpinnerProps> = ({
  className,
  size = "2rem",
  strokeClassName,
}) => {
  return (
    <div className={cn(className)} style={{ width: size, height: size }}>
      <div className="relative h-full w-full">
        <svg
          className="cy-spinner absolute left-0 top-0 origin-center -rotate-90 animate-[spinner-rotate-animation_2000ms_linear_infinite] overflow-visible"
          preserveAspectRatio="xMidYMid meet"
          focusable="false"
          aria-hidden="true"
          viewBox="0 0 100 100"
          style={{ width: size, height: size }}
        >
          <circle
            cx="50%"
            cy="50%"
            r={45}
            className={cn(
              strokeClassName,
              "cy-spinner__circle",
              "stroke-current",
            )}
            style={{
              animationName: "mat-progress-spinner-stroke-rotate-100",
              strokeDasharray: "282.743px",
              strokeWidth: "10%",
              transformOrigin: "50% 50%",
            }}
          />
        </svg>
      </div>
    </div>
  );
};

export default Spinner;
